import type {Account, AuthedUserAccount} from 'src/types/account';
import type {State} from 'src/reducers';
import type {Privilege} from 'src/action-creators/roles';

import {createSelector} from 'reselect';
import get from 'lodash/get';

import {EDIT_SETTINGS} from 'src/action-creators/roles';


export const getCurrentAgent = ({
  accounts,
}: State): Account | AuthedUserAccount | null | undefined =>
  accounts.authedUserId ? accounts.data[accounts.authedUserId] : null;

export const selectCurrentAccount = getCurrentAgent;

export const selectIsAuthed = ({accounts}: State): boolean => accounts.isAuthed;

export const getAllAgents = ({
  accounts,
}: State): {
  [key: string]: Account | AuthedUserAccount;
} => accounts.data;

export const getAgentsByAgentIds: (
  state: State,
  agentIds: string[],
) => Account | AuthedUserAccount[] = createSelector(
  getAllAgents,
  // @ts-expect-error - TS7006 - Parameter '_state' implicitly has an 'any' type. | TS7006 - Parameter 'agentIds' implicitly has an 'any' type.
  (_state, agentIds) => agentIds,
  (
    allAgents: {
      [key: string]: Account | AuthedUserAccount;
    },
    agentIds,
  ) => {
    // @ts-expect-error - TS7006 - Parameter 'agentId' implicitly has an 'any' type.
    const results = agentIds.map((agentId) => allAgents[agentId]);
    return results;
  },
);

// @ts-expect-error - TS2322 - Type 'OutputSelector<any, boolean, (res: Account | AuthedUserAccount | null | undefined) => boolean>' is not assignable to type '(state: any) => Record<any, any>'.
export const getCanEditSettings: (state: State) => Record<any, any> =
  createSelector(getCurrentAgent, (currentAgent) =>
    get(currentAgent, ['securityRole', 'privileges'], []).includes(
      // @ts-expect-error - TS2345 - Argument of type '"EDIT_SETTINGS"' is not assignable to parameter of type 'never'.
      EDIT_SETTINGS,
    ),
  );

export const getAccountPrivileges: (
  state: State,
) => Privilege[] | null | undefined = createSelector(
  getCurrentAgent,
  (currentAgent) => currentAgent?.securityRole.privileges,
);

export const selectUserAgent = (state: State): string =>
  state.requestHeaders?.headers['user-agent'];
